// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.attachments {\n\twidth: 210px;\n}\n\n/* show icon + text for Download all button\n\t\tas well as when there is only one attachment */\n.attachments-save-to-cloud {\n\tdisplay: block;\n\tmargin: 3px auto 0 auto;\n\tbackground-position: 9px center;\n\tpadding-left: 32px;\n}\n", ""]);
// Exports
module.exports = exports;
